import { defineChannel, type ChannelDefinition } from '../channel-definition';

export const inboxChannel = defineChannel({
  id: 'inbox',
  icon: 'notifications',
  name: 'Inbox message',
  shortName: 'Inbox Message',
  noun: 'inbox message',
  events: ['attempted', 'sent', 'deferred', 'failed', 'opened', 'converted', 'drafted', 'undeliverable'],
  deliveryStates: ['attempted', 'sent', 'failed', 'holdout'],
  deliveryActions: ['opened', 'clicked', 'converted'],
} as const satisfies ChannelDefinition);
